import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Server, ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left: brand / image */}
      <div className="relative hidden md:flex flex-col justify-between p-10 overflow-hidden">
        <div className="absolute inset-0 bg-[#0b1a3a]" />
        <img
          src="https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Infraestructura IT"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center">
            <Server className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="font-display font-bold text-2xl text-white tracking-tight">JDMTECH</span>
        </div>
        <div className="relative z-10 text-white">
          <h1 className="font-display text-3xl font-bold leading-tight">CRM de servicios IT</h1>
          <p className="mt-3 text-white/70 max-w-sm">
            Gestiona clientes, trabajos y presupuestos desde cualquier lugar. Rápido, ordenado y siempre a mano.
          </p>
        </div>
      </div>

      {/* Right: login */}
      <div className="flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm">
          <div className="md:hidden flex items-center gap-3 mb-8">
            <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center">
              <Server className="h-5 w-5 text-primary-foreground" />
            </div>
            <span className="font-display font-bold text-2xl tracking-tight">JDMTECH</span>
          </div>
          <h2 className="font-display text-2xl font-bold tracking-tight">Iniciar sesión</h2>
          <p className="text-muted-foreground mt-2 text-sm">
            Acceso restringido al propietario del negocio.
          </p>

          <Button onClick={handleLogin} data-testid="google-login-button"
            className="w-full mt-8 h-12 text-base font-semibold">
            Continuar con Google
          </Button>

          <div className="mt-6 flex items-start gap-2 text-xs text-muted-foreground">
            <ShieldCheck className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
            <span>Solo tu cuenta autorizada puede entrar. No existe registro público.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
